"use strict";

(function(z, Backbone){

    var ProjectsRepresentativesContractsCollection = Backbone.Collection.extend({
        // nothing
    });

    z.ProjectsRepresentativesContractsCollection = ProjectsRepresentativesContractsCollection;

})(window.z = window.z || {}, Backbone);